import styled, { css } from 'styled-components';
import { Button, OutlineButton } from '@chegg-ui/button';
import { Link } from '@chegg-ui/link';
import { Textarea } from '@chegg-ui/textarea';
import { CHEGG_SIHP } from './types';
import { GoogleDriveIcon as UiGoogleDriveIcon, LaptopIcon as UiLaptopIcon, WarningIcon, colors, font, spacing, visuallyHiddenCss } from '@chegg-ui/theme';
// this is an example styled-component export, replace with your own needed styles
export var UploadWidgetContainer = styled.div.withConfig({
  componentId: "sc-ib4gnf-0"
})(["margin:0;font-family:", ";"], font.family["default"]);
var handlePrimaryButtonColor = css(["background-color:", ";color:", ";border-color:", ";&:hover{background-color:", ";border-color:", ";}"], function (_ref) {
  var buttonColor = _ref.buttonColor;
  return buttonColor || colors.cheggOrange;
}, function (_ref2) {
  var buttonTextColor = _ref2.buttonTextColor;
  return buttonTextColor || colors.white;
}, function (_ref3) {
  var buttonColor = _ref3.buttonColor;
  return buttonColor || colors.cheggOrange;
}, function (_ref4) {
  var buttonHoverColor = _ref4.buttonHoverColor;
  return buttonHoverColor || colors.orangeDark;
}, function (_ref5) {
  var buttonHoverColor = _ref5.buttonHoverColor;
  return buttonHoverColor || colors.orangeDark;
});
var handleOutlineButtonColorHover = css(["background-color:", ";border-color:", ";color:", ";"], function (_ref6) {
  var buttonHoverColor = _ref6.buttonHoverColor;
  return buttonHoverColor || colors.orangeDark;
}, function (_ref7) {
  var buttonHoverColor = _ref7.buttonHoverColor;
  return buttonHoverColor || colors.orangeDark;
}, function (_ref8) {
  var buttonTextColor = _ref8.buttonTextColor;
  return buttonTextColor || colors.white;
});
var handleOutlineButtonColor = css(["border-color:", ";color:", ";&:hover{", "}"], function (_ref9) {
  var buttonColor = _ref9.buttonColor;
  return buttonColor || colors.cheggOrange;
}, function (_ref10) {
  var buttonColor = _ref10.buttonColor;
  return buttonColor || colors.cheggOrange;
}, handleOutlineButtonColorHover);
var handleDisabledButtonColor = css(["color:", ";background-color:", ";border-color:", ";", " &:hover{color:", ";background-color:", ";border-color:", ";}"], function (_ref11) {
  var buttonDisabledTextColor = _ref11.buttonDisabledTextColor;
  return buttonDisabledTextColor || colors.greyMedium;
}, function (_ref12) {
  var buttonDisabledColor = _ref12.buttonDisabledColor;
  return buttonDisabledColor || colors.greyLight;
}, function (_ref13) {
  var buttonDisabledColor = _ref13.buttonDisabledColor;
  return buttonDisabledColor || colors.greyLight;
}, function (_ref14) {
  var disabledOpacity = _ref14.disabledOpacity;
  return disabledOpacity && css(["opacity:", ";"], disabledOpacity);
}, function (_ref15) {
  var buttonDisabledTextColor = _ref15.buttonDisabledTextColor;
  return buttonDisabledTextColor || colors.greyMedium;
}, function (_ref16) {
  var buttonDisabledColor = _ref16.buttonDisabledColor;
  return buttonDisabledColor || colors.greyLight;
}, function (_ref17) {
  var buttonDisabledColor = _ref17.buttonDisabledColor;
  return buttonDisabledColor || colors.greyLight;
});
var handleBorderRadius = css(["", ""], function (_ref18) {
  var borderRadius = _ref18.borderRadius;
  return borderRadius && css(["border-radius:", ";"], borderRadius);
});
export var Title = styled.h2.withConfig({
  componentId: "sc-ib4gnf-1"
})(["color:", ";margin:0;font-family:", ";font-size:", ";font-weight:", ";line-height:", ";text-align:", ";", " ", ""], colors.dark, font.family["default"], font.size.px32, font.weight.bold, font.lineHeight.sm, function (_ref19) {
  var textAlign = _ref19.textAlign;
  return textAlign;
}, function (_ref20) {
  var site = _ref20.site;
  return site === CHEGG_SIHP ? "\n    font-size: 24px !important;\n    font-weight: 400 !important;\n  " : '';
}, function (_ref21) {
  var addMarginBottom = _ref21.addMarginBottom;
  return addMarginBottom ? "\n    margin-bottom: 32px !important;\n  " : '';
});
export var LaptopIcon = styled(UiLaptopIcon).attrs({
  size: 'small'
}).withConfig({
  componentId: "sc-ib4gnf-2"
})(["margin-right:", ";"], spacing.px4);
export var GoogleDriveIcon = styled(UiGoogleDriveIcon).attrs({
  size: 'small'
}).withConfig({
  componentId: "sc-ib4gnf-3"
})(["margin-right:", ";"], spacing.px4);
export var ImportantIcon = styled(WarningIcon).attrs({
  size: 'small',
  color: colors.errorRed
}).withConfig({
  componentId: "sc-ib4gnf-4"
})(["margin-right:", ";"], spacing.px4);
export var CheckPaperButton = styled(Button).withConfig({
  componentId: "sc-ib4gnf-5"
})(["flex:1;width:100%;display:flex;align-items:center;", " ", " &:disabled{cursor:not-allowed;", "}", ""], handlePrimaryButtonColor, handleBorderRadius, handleDisabledButtonColor, function (_ref22) {
  var fontSize = _ref22.fontSize;
  return fontSize && css(["font-size:", ";"], fontSize);
});
var UploadButton = styled(OutlineButton).withConfig({
  componentId: "sc-ib4gnf-6"
})(["flex-grow:1;flex-shrink:1;flex-basis:50%;width:100%;", " ", " &,", ",", "{", "}&:hover ", ",&:hover ", "{", "}&:disabled,&:disabled ", ",&:disabled ", "{", "}"], handleBorderRadius, function (_ref23) {
  var fontSize = _ref23.fontSize;
  return fontSize && css(["font-size:", ";"], fontSize);
}, LaptopIcon, GoogleDriveIcon, handleOutlineButtonColor, LaptopIcon, GoogleDriveIcon, handleOutlineButtonColorHover, LaptopIcon, GoogleDriveIcon, handleDisabledButtonColor);
export var UploadComputerButton = styled(UploadButton).withConfig({
  componentId: "sc-ib4gnf-7"
})(["margin-right:", ";"], spacing.px8);
export var ComputerFileInput = styled.input.withConfig({
  componentId: "sc-ib4gnf-8"
})(["", ""], visuallyHiddenCss);
export var UploadGDriveButton = styled(UploadButton).withConfig({
  componentId: "sc-ib4gnf-9"
})(["margin-left:", ";padding-left:", ";padding-right:", ";"], spacing.px8, spacing.px4, spacing.px4);
export var DocumentTextAreaContainer = styled.div.withConfig({
  componentId: "sc-ib4gnf-10"
})(["margin-top:10px;background-color:#fff;padding:0;"]);
export var PastePaperTextArea = styled(Textarea).attrs({
  visuallyHideLabel: true
}).withConfig({
  componentId: "sc-ib4gnf-11"
})(["textarea{resize:none;border:none;}"]);
export var TermsConditionsContainer = styled.div.withConfig({
  componentId: "sc-ib4gnf-12"
})(["margin-top:-", ";> a{color:", ";text-decoration:none;}"], spacing.px8, function (_ref24) {
  var textColor = _ref24.textColor;
  return textColor || colors.white;
});
export var ErrorContainer = styled.div.withConfig({
  componentId: "sc-ib4gnf-13"
})(["display:flex;align-items:center;padding:", " ", ";background-color:", ";margin-bottom:", ";"], spacing.px12, spacing.px8, colors.coralLight, spacing.px12);
export var ErrorText = styled.span.withConfig({
  componentId: "sc-ib4gnf-14"
})(["margin-left:", ";font-size:", ";"], spacing.px4, font.size.px16);
export var ErrorCloseContainer = styled.div.withConfig({
  componentId: "sc-ib4gnf-15"
})(["margin-left:auto;cursor:pointer;"]);
export var DividerWrapper = styled.div.withConfig({
  componentId: "sc-ib4gnf-16"
})(["display:flex;flex-direction:row;justify-content:center;margin:15px 0;color:#999;"]);
export var Divider = styled.div.withConfig({
  componentId: "sc-ib4gnf-17"
})(["border-bottom:2px solid #e7e7e7;width:27px;margin:8px 12px;"]);
export var TextAreaWrapper = styled.div.withConfig({
  componentId: "sc-ib4gnf-18"
})(["border:2px solid ", ";margin-bottom:", ";& > div{margin-bottom:0px;}"], colors.greyLight, spacing.px8);
export var DemoText = styled(Link).withConfig({
  componentId: "sc-ib4gnf-19"
})(["font-size:16px;padding:8px 14px;cursor:pointer;"]);
export var TooltipWrapper = styled.div.withConfig({
  componentId: "sc-ib4gnf-20"
})(["background-color:", ";text-align:right;"], colors.white);